import React from 'react';
import { useMutation } from '@apollo/client';
import ClonePaymentMutation from './ClonePaymentMutation';

interface IClonePaymentConnectorApollo {
  children: ({ clonePayment }: { clonePayment: () => Promise<unknown> }) => React.ReactElement;
  token: string;
  source?: string;
}

const ClonePaymentConnectorApollo: React.FC<IClonePaymentConnectorApollo> = ({
  children,
  token,
  source,
}) => {
  const [clonePayment] = useMutation(ClonePaymentMutation);

  const createClonePayment = async () => {
    const response = await clonePayment({
      variables: {
        token,
        source,
      },
    });

    return response;
  };

  return children({ clonePayment: createClonePayment });
};

export default ClonePaymentConnectorApollo;
